import { Component } from "react";
import * as React from "react";
import { classNames } from "./utils.js";
import { stylesheet } from "typestyle";
import { em, rem } from "csx";
function getListLayoutClass(layout) {
    switch (layout) {
        case "grid": return styles.listLayoutGrid;
        case "horizontal": return styles.listLayoutHorizontal;
        case "vertical": return styles.listLayoutVertical;
    }
}
export const List = ({ children, className, layout = 'grid', transparent }) => (React.createElement("div", { className: classNames(styles.list, !transparent && styles.listBackground, getListLayoutClass(layout), className) }, children));
export class ListItem extends Component {
    render() {
        const { children, onClick, disabled, className } = this.props;
        return (React.createElement("div", { className: classNames(styles.listItem, disabled ? styles.listItemDisabled : undefined, className), onClick: onClick }, children));
    }
}
export const ListItemIcon = ({ children }) => (React.createElement("div", { className: styles.listItemIcon }, children));
export const ListItemText = ({ children, className }) => (React.createElement("div", { className: classNames(styles.listItemText, className) }, children));
export const ListItemName = ({ children }) => (React.createElement("div", { className: styles.listItemName }, children));
export const ListItemDescription = ({ children }) => (React.createElement("div", { className: styles.listItemDescription }, children));
const styles = stylesheet({
    list: {
        padding: em(1),
        display: 'grid',
        gridGap: "1em 1em"
    },
    listBackground: {
        background: '#f6f6f6',
    },
    listLayoutGrid: {
        gridTemplateColumns: "repeat(auto-fit, minmax(20em, 1fr))",
    },
    listLayoutHorizontal: {
        gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))",
    },
    listLayoutVertical: {
        gridTemplateColumns: "repeat(auto-fit, 1fr)",
    },
    listItem: {
        display: "flex",
        flexFlow: "row nowrap",
        alignItems: "center",
        background: "var(--color-background)",
        border: "1px solid #f0f0f0",
        borderBottom: "1px solid #ccc",
        padding: "0.5em 1em"
    },
    listItemDisabled: {
        color: "var(--color-disabled)",
    },
    listItemIcon: {
        flex: 0,
        fontSize: em(1.5),
        marginRight: rem(1),
        $nest: {
            '&:last-child': {
                marginRight: 0
            }
        }
    },
    listItemText: {
        flex: "1 1 auto",
        minWidth: 0
    },
    listItemName: {
        fontSize: em(1.5),
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    listItemDescription: {
        fontWeight: 300,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }
});
//# sourceMappingURL=list.js.map